import React from 'react';

const EditOrgMobileSkeleton = () => (
  <div
    className="animate-pulse flex relative items-center justify-center flex-1 bg-linear-to-t from-white to-gray-200"
    style={{ aspectRatio: '9/16' }}
  >
    <div className="left-0 right-0 top-[40%] absolute px-5">
      <div className="align-center justify-center flex">
        <div className="h-[100px] w-[100px] bg-gray-200 rounded-xl" />
      </div>
      <div className="mt-6 h-[40px] w-full bg-gray-200 rounded-xl" />
      <div className="mt-4 h-[30px] w-full bg-gray-200 rounded-xl" />
      <div className="mt-6 h-[130px] w-full bg-gray-200 rounded-xl" />
    </div>
  </div>
);

export default EditOrgMobileSkeleton;
